import React from "react"

type modalProps = {
    closeModal: () => void,
    onAceptTerms: () => void
}

export const ModalTerms = ({ closeModal, onAceptTerms }: modalProps) => {

    return (
        <div className="modal">
            <div className="modal-body modal-terms-body">
                <div className="modal-header">DESCARGO DE RESPONSABILIDADES DE AVIATION SECURITY GROUP SAC</div>
                <div className="modal-content">
                    <p>
                        La plataforma de capacitación AVIATION SECURITY GROUP SAC (ASG) tiene como objetivo proporcionar contenido educativo y formativo a sus empleados, colaboradores y usuarios registrados. Al utilizar esta plataforma, usted acepta y está de acuerdo con los siguientes términos y condiciones:
                    </p>
                    <br></br>
                    <p>
                        <ol type="1">
                            <li>
                                <b>Propósito del Contenido: </b>
                                <span>El contenido proporcionado en esta plataforma tiene fines exclusivamente informativos y educativos. No debe considerarse como asesoramiento profesional en áreas específicas, como legal, financiero o médico.</span>
                            </li>
                            <li>
                                <b>Limitación de Responsabilidad: </b>
                                <span>ASG no se hace responsable de los daños, pérdidas o inconvenientes derivados del uso de la información o materiales proporcionados en esta plataforma. Los usuarios son responsables de la aplicación del contenido aprendido en su trabajo y actividades profesionales.</span>
                            </li>
                            <li>
                                <b>Actualización de Contenidos: </b>
                                <span>Los materiales de capacitación pueden estar sujetos a actualizaciones y modificaciones sin previo aviso. ASG no garantiza la disponibilidad o exactitud de los contenidos en todo momento.</span>
                            </li>
                            <li>
                                <b>Acceso y Seguridad: </b>
                                <span>El acceso a la plataforma es exclusivo para usuarios autorizados. ASG se reserva el derecho de modificar, suspender o deshabilitar el acceso a la plataforma en cualquier momento, sin previo aviso, por razones de mantenimiento o de seguridad.</span>
                            </li>
                            <li>
                                <b>Exclusión de Responsabilidad por Terceros: </b>
                                <span>ASG no se hace responsable de los enlaces, recursos o contenidos proporcionados por terceros a través de la plataforma. Cualquier interacción con terceros es responsabilidad exclusiva del usuario.</span>
                            </li>
                            <li>
                                <b>Aceptación de Riesgos: </b>
                                <span>Al participar en la plataforma de capacitación, el usuario acepta que cualquier error en la interpretación o aplicación del contenido es de su responsabilidad. ASG no asume ninguna obligación o responsabilidad por las decisiones tomadas basadas en la capacitación recibida.</span>
                            </li>
                            <li>
                                <b>Modificación del Disclaimer: </b>
                                <span>ASG se reserva el derecho de modificar este disclaimer en cualquier momento. Las actualizaciones serán publicadas en esta página y entrarán en vigencia de inmediato.</span>
                            </li>
                        </ol>
                    </p>
                    <br></br>
                    <p>
                        La marca ASG está protegida por las leyes de propiedad intelectual registradas en Indecopi. Cualquier reproducción total o parcial de la misma, así como su uso fuera de esta plataforma, constituye una infracción y será sancionada de acuerdo con la legislación vigente del Estado Peruano.
                    </p>
                    <br></br>
                    <p>
                        Aviation Security Group S.A.C, RUC 20462792396, Registro en Indecopi: S00144099, fecha vigencia: 2032-12-23
                    </p>
                </div>
                <div className="modal-footer">
                    <button onClick={() => onAceptTerms()}>
                        Declaro haber leído y aceptado las condiciones y políticas
                    </button>
                </div>
            </div>
        </div>
    )
}